import React from 'react'

import InfoFeatures from '../../components/Info/Features'
import Feature from '../../components/Feature'
import cloudDocs from './completed-tasks.svg'
import education from './my-answer.svg'
import steppingUp from './date-picker.svg'

const Features = () => {
  return (
    <InfoFeatures title="High Quality Online Education">
      <Feature
        title="Collaborative Learning Environment"
        src={steppingUp}
        alt="A person reading a calendar."
      >
        Online tools allow tutor and tutee to collaborate on questions together
      </Feature>
      <Feature
        title="Ask more questions"
        src={education}
        alt="A person holding a task in a hand, with two more underneath it."
      >
        We have found that students love learning in remote environment as they
        tend to ask more questions to clarify their doubts
      </Feature>
      <Feature
        title="Flexible Schedule"
        src={cloudDocs}
        alt="Two people building a schedule. The first item in the schedule is marked as completed, but two people are holding additional documents, suggesting they want to modify the schedule."
      >
        With remote tutoring, students are able to decide on lesson timings that
        best fit their hectic school schedule
      </Feature>
    </InfoFeatures>
  )
}

export default Features
